<aside
  tabindex="-1"
  aria-hidden="true"
  class="damage-example-offcanvas"
  [ngClass]="{
    hidden: !isOpen(),
    'mobi-ui-animation-appear-up-init mobi-ui-animation-appear-active show': isOpen(),
  }"
  (swipedown)="onCloseOverlay()"
  trapFocus
>
  <div class="mobi-ui-container mobi-ui-padding-t-md">
    <button
      aria-label="Close overlay"
      class="absolute top-2 right-2"
      (click)="onCloseOverlay()"
    >
      <mobi-ui-icon-major name="the_x" class="close-overlay" />
    </button>
    <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
    <ng-content /><ng-container [ngTemplateOutlet]="content()"></ng-container>
  </div>
</aside>
<button
  class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"
  [class]="{ hidden: !isOpen() }"
  (keyup)="onCloseOverlay()"
  (click)="onCloseOverlay()"
>
  &nbsp;
</button>
